import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/export_block1.png';
import _imports_1 from '@/assets/export_zhaopin.png';
const _withScopeId = n => (_pushScopeId("data-v-7feaf8e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "fs-s"
};
const _hoisted_2 = {
  class: "block block1"
};
const _hoisted_3 = {
  class: "text-box d-flex jc-between ai-center main-width"
};
const _hoisted_4 = {
  class: "text-white text-left"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logotitle fs-m light_blue text-orange"
}, "成为赋能官", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title pt-10 pb-20 fs-xl fw-b"
}, "培养碳界领军人物", -1));
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_9 = {
  class: "block block2 bg-lightgray"
};
const _hoisted_10 = {
  class: "main-width m_box"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fs-l fw-b text-blue pb-10"
}, "赋能官培训", -1));
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = {
  class: "img_box d-flex"
};
const _hoisted_14 = {
  class: "block block4"
};
const _hoisted_15 = {
  class: "main-width text-white content_box"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fs-l fw-b"
}, [/*#__PURE__*/_createTextVNode("准备好成为一名"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("赋能官了吗？")], -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fs-m pt-20 blue"
}, "申请要求", -1));
const _hoisted_18 = {
  class: "d-flex jc-between pt-20"
};
const _hoisted_19 = {
  class: "text-box"
};
const _hoisted_20 = ["innerHTML"];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
import { useRouter } from 'vue-router';
import wx from 'weixin-js-sdk';
import { onMounted } from 'vue';
import { useStore } from 'vuex';
export default {
  __name: 'Export',
  setup(__props) {
    const router = useRouter();
    const store = useStore();
    const textData = {
      block1: '加入碳手印赋能团队，致力于通过教<br>练技术帮助更多人成为碳界领导者',
      block2: '参加“碳手印项目咨询辅导力”专项培训课程，并通过考核认定，获取国际碳手印组织颁发的<br>《碳手印活动咨询辅导力培训结业证书》',
      block3: '在全球范围内，<br>我们的教育工作者正在引领运动，<br>推动健康低碳的场所。',
      block5: '超过80%的优秀赋能官从WELL碳手印标准开始，<br>去看看我们的标准吧。'
    };
    const signupList = ['① 具有一定专业知识、培训和咨询能力，致力于<br>通过辅导方式帮助客户取得品牌提升。', '② 认同碳手印活动机制能够帮助自身资源成功获<br>取项目。', '③ 认同赋能官机制能够助力自身项目成功变现。'];
    const toPage = url => {
      router.push({
        path: url
      });
    };
    const downloadFile = () => {
      const fileUrl = 'https://res.carbonhp.com/assetbundles/carbon/CHEO_ APPLICATION.docx';
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', 'WELL碳手印领军人物申报书.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
    const toApplyPage = () => {
      location.href = "https://f.wps.cn/g/2Rr8dVQf/";
    };
    const wxFunc = function () {
      const params = store.state.VUEX_SHARECONFIG.export;
      wx.ready(function () {
        //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
          ...params,
          success: function () {
            // 设置成功
          }
        });
      });
    };
    onMounted(() => {
      wxFunc();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createElementVNode("div", {
        class: "slogantext pb-20",
        innerHTML: textData.block1
      }, null, 8, _hoisted_7), _createVNode(_component_el_button, {
        class: "btn text-purple",
        color: "#fff",
        onClick: toApplyPage
      }, {
        default: _withCtx(() => [_createTextVNode("申请成为赋能官")]),
        _: 1
      }), _hoisted_8])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", {
        class: "content fs-m pb-40",
        innerHTML: textData.block2
      }, null, 8, _hoisted_12), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_image, {
        class: "img-1",
        fit: "contain",
        src: require('@/assets/export_office1.png')
      }, null, 8, ["src"]), _createVNode(_component_el_image, {
        fit: "contain",
        src: require('@/assets/export_office2.png')
      }, null, 8, ["src"])])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(signupList, (item, idx) => {
        return _createElementVNode("div", {
          class: "",
          key: idx
        }, [_createElementVNode("div", {
          class: "pb-20",
          innerHTML: item
        }, null, 8, _hoisted_20)]);
      }), 64)), _createVNode(_component_el_button, {
        class: "btn text-purple",
        color: "#fff",
        onClick: toApplyPage
      }, {
        default: _withCtx(() => [_createTextVNode("申请成为赋能官")]),
        _: 1
      }), _hoisted_21])])])])]);
    };
  }
};